import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaBell, FaMobileAlt, FaUserFriends, FaClipboardList, FaUsers } from "react-icons/fa";
import { CrmMobileMockup } from "./CrmMockups";
import { CrmReveal } from "./CrmMotion";

const screens = [
    { title: "Lead Updates", icon: FaClipboardList, index: 0 },
    { title: "Customer Profiles", icon: FaUserFriends, index: 1 },
    { title: "Follow-Up Reminders", icon: FaBell, index: 2 },
    { title: "Notifications", icon: FaMobileAlt, index: 3 },
    { title: "Team Collaboration", icon: FaUsers, index: 4 },
];

export const CrmMobileSection = () => {
    const [active, setActive] = useState(0);

    return (
        <section className="crm-mobile">
            <div className="crm-container">
                <CrmReveal className="crm-mobile__header">
                    <h2 className="crm-h2">Manage Your Business Anywhere</h2>
                    <div className="crm-section-accent crm-section-accent--center" />
                    <p className="crm-lead">
                        Access lead updates, customer profiles, follow-up reminders, and team collaboration
                        from any device — your CRM goes wherever you go.
                    </p>
                </CrmReveal>

                <div className="crm-mobile__body">
                    <div className="crm-mobile__tabs">
                        {screens.map((s, i) => {
                            const Icon = s.icon;
                            return (
                                <motion.button
                                    key={s.title}
                                    type="button"
                                    className={`crm-mobile__tab ${active === i ? "crm-mobile__tab--on" : ""}`}
                                    onClick={() => setActive(i)}
                                    whileHover={{ scale: 1.02 }}
                                    whileTap={{ scale: 0.98 }}
                                >
                                    <Icon size={16} />
                                    <span>{s.title}</span>
                                </motion.button>
                            );
                        })}
                    </div>

                    <div className="crm-mobile__phones">
                        <AnimatePresence mode="wait">
                            <motion.div
                                key={active}
                                className="crm-mobile__phone-wrap"
                                initial={{ opacity: 0, y: 24, rotateY: -8 }}
                                animate={{ opacity: 1, y: 0, rotateY: 0 }}
                                exit={{ opacity: 0, y: -16, rotateY: 8 }}
                                transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
                            >
                                <CrmMobileMockup screenIndex={screens[active].index} />
                            </motion.div>
                        </AnimatePresence>
                        <motion.div
                            className="crm-mobile__phone-shadow"
                            animate={{ scale: [1, 1.04, 1] }}
                            transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};
